import ChildPageHeader from '@/components/UI/ChildPageHeader'
import UserConversations from '../UserSessionDetails/UserConversations'
import { useGlobalContext } from '@/context/GlobalContext'
import dayjs from 'dayjs'

const LearnerConversations = (props: any) => {
  const { sessionsData } = useGlobalContext()
  const sessionData = sessionsData.find(
    (item: any) => item._id === props.match.params.sessionId,
  )

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader
        variant="compact"
        title={
          sessionData?.session_name ||
          dayjs
            .utc(sessionData?.created_at)
            .local()
            .format('DD/MM/YYYY hh:mm A')
        }
      />

      <UserConversations sessionId={props.match.params.sessionId} />
    </section>
  )
}

export default LearnerConversations
